import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
const DEMO_URL = 'https://calendar.app.google/kAzzsMuwfngdzNZf9';
export function ContactPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const {
    t
  } = useTranslation();
  const faqKeys = [{
    q: 'contact.faq0Q',
    a: 'contact.faq0A'
  }, {
    q: 'contact.faq1Q',
    a: 'contact.faq1A'
  }, {
    q: 'contact.faq2Q',
    a: 'contact.faq2A'
  }];
  return <div className="pt-24" data-id="element-360">
      <section className="relative py-24 overflow-hidden" data-id="element-361">
        <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-362">
          <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-363">
            {t('contact.heroTitle')}
            <span className="text-gradient" data-id="element-364">
              {t('contact.heroTitleHighlight')}
            </span>
          </h1>
          <p className="text-xl text-white/60 leading-relaxed max-w-3xl mx-auto" data-id="element-365">
            {t('contact.heroDesc')}
          </p>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-366">
        <div className="max-w-3xl mx-auto px-6" data-id="element-367">
          <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-368">
            <div data-id="element-369">
              <label className="block text-sm font-medium text-white/60 mb-2" data-id="element-370">
                {t('contact.nameLabel')}
              </label>
              <input type="text" className="w-full bg-[#050505] border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-white/30 transition-colors" placeholder={t('contact.namePlaceholder')} data-id="element-371" />
            </div>
            <div data-id="element-372">
              <label className="block text-sm font-medium text-white/60 mb-2" data-id="element-373">
                {t('contact.emailLabel')}
              </label>
              <input type="email" className="w-full bg-[#050505] border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-white/30 transition-colors" placeholder={t('contact.emailPlaceholder')} data-id="element-374" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-375">
              <div data-id="element-376">
                <label className="block text-sm font-medium text-white/60 mb-2" data-id="element-377">
                  {t('contact.companyLabel')}
                </label>
                <input type="text" className="w-full bg-[#050505] border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-white/30 transition-colors" placeholder={t('contact.companyPlaceholder')} data-id="element-378" />
              </div>
              <div data-id="element-379">
                <label className="block text-sm font-medium text-white/60 mb-2" data-id="element-380">
                  {t('contact.roleLabel')}
                </label>
                <div className="relative" data-id="element-381">
                  <select className="w-full bg-[#050505] border border-white/10 rounded-xl px-4 py-3 text-white appearance-none focus:outline-none focus:border-white/30 transition-colors" data-id="element-382">
                    <option value="" data-id="element-383">{t('contact.roleSelectRole')}</option>
                    <option value="dmo" data-id="element-384">{t('contact.roleDmo')}</option>
                    <option value="agency" data-id="element-385">{t('contact.roleAgency')}</option>
                    <option value="hotel" data-id="element-386">{t('contact.roleHotel')}</option>
                    <option value="realestate" data-id="element-387">
                      {t('contact.roleRealestate')}
                    </option>
                    <option value="other" data-id="element-388">{t('contact.roleOther')}</option>
                  </select>
                  <ChevronDownIcon className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40 pointer-events-none" data-id="element-389" />
                </div>
              </div>
            </div>
            <div data-id="element-390">
              <label className="block text-sm font-medium text-white/60 mb-2" data-id="element-391">
                {t('contact.messageLabel')}
              </label>
              <textarea rows={5} className="w-full bg-[#050505] border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-white/30 transition-colors resize-none" placeholder={t('contact.messagePlaceholder')} data-id="element-392"></textarea>
            </div>
            <div className="flex justify-center" data-id="element-393">
              <button type="button" className="w-[280px] bg-gradient-animated rounded-full px-6 py-4 text-base font-semibold text-white hover:opacity-90 transition-opacity" data-id="element-394">
                {t('contact.sendMessage')}
              </button>
            </div>
          </form>
          <p className="text-white/40 text-sm mt-6 text-center" data-id="element-395">
            {t('contact.responseTime')}
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-396">
        <div className="max-w-3xl mx-auto px-6" data-id="element-397">
          <div className="relative rounded-3xl p-[1px] overflow-hidden" data-id="element-398">
            <div className="absolute inset-0 bg-gradient-animated rounded-3xl" data-id="element-399"></div>
            <div className="relative bg-[#0A0A0A] rounded-[calc(1.5rem-1px)] p-10 md:p-16 text-center z-10" data-id="element-400">
              <h3 className="text-2xl font-bold mb-3" data-id="element-401">
                {t('contact.demoTitle')}
              </h3>
              <p className="text-white/60 mb-8" data-id="element-402">{t('contact.demoDesc')}</p>
              <a href={DEMO_URL} target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-4 text-base font-semibold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(123,47,255,0.3)]" data-id="element-403">
                {t('contact.demoCta')}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-404">
        <div className="max-w-3xl mx-auto px-6" data-id="element-405">
          <h2 className="text-3xl font-bold mb-12 text-center" data-id="element-406">
            {t('contact.faqTitle')}
            <span className="text-gradient" data-id="element-407">{t('contact.faqHighlight')}</span>
          </h2>
          <div className="space-y-4" data-id="element-408">
            {faqKeys.map((faq, idx) => <div key={idx} className="border border-white/10 rounded-2xl bg-[#050505] overflow-hidden" data-id="element-409">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenFaq(openFaq === idx ? null : idx)} data-id="element-410">
                  <span className={`font-medium ${openFaq === idx ? 'text-gradient' : 'text-white'}`} data-id="element-411">
                    {t(faq.q)}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-white/40 transition-transform duration-300 ${openFaq === idx ? 'rotate-180' : ''}`} data-id="element-412" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ${openFaq === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-413">
                  <p className="text-white/60 leading-relaxed" data-id="element-414">{t(faq.a)}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}